import { connectFirestoreEmulator, collection, doc, enableIndexedDbPersistence, getFirestore, } from 'firebase/firestore';
import { getEmulatorHost, getEmulatorPort } from '../emulator-detection.js';
const connectedInstances = new WeakSet();
/** Returns the Firestore instance associated with the Firebase app. */
export function getFirestoreDb(app) {
    return getFirestore(app);
}
/** Connects Firestore to the emulator host exactly once. */
export function connectFirestoreToEmulator(firestore, config) {
    if (connectedInstances.has(firestore)) {
        return;
    }
    connectFirestoreEmulator(firestore, getEmulatorHost(config), getEmulatorPort(config));
    connectedInstances.add(firestore);
}
/**
 * Helper to create typed collection references without repeating generics at
 * every call site. Keeps teaching snippets concise.
 */
export function createCollection(db, path) {
    return collection(db, path);
}
/**
 * Helper to create typed document references.
 */
export function createDocument(db, path) {
    return doc(db, path);
}
/**
 * Builds a `FirestoreDataConverter` from simple serialize/deserialize lambdas.
 */
export function makeConverter(config) {
    return {
        toFirestore: config.toFirestore,
        fromFirestore: config.fromFirestore,
    };
}
const persistenceEnabled = new WeakSet();
/**
 * Enables IndexedDB-backed offline persistence for a Firestore instance. Safe
 * to call multiple times; subsequent calls become no-ops.
 */
export async function enableFirestoreOfflinePersistence(db) {
    if (persistenceEnabled.has(db)) {
        return true;
    }
    try {
        await enableIndexedDbPersistence(db, {
            forceOwnership: false, // Allow multiple tabs
        });
        persistenceEnabled.add(db);
        console.log('[firebase/firestore] Offline persistence enabled successfully');
        return true;
    }
    catch (error) {
        const code = error?.code;
        if (code === 'failed-precondition') {
            console.warn('[firebase/firestore] Offline persistence is already enabled in another tab. Continuing with memory cache.');
            persistenceEnabled.add(db); // Mark as "handled" so we don't retry
            return false;
        }
        if (code === 'unimplemented') {
            console.warn('[firebase/firestore] Offline persistence is not supported in this environment. Continuing with memory cache.');
            persistenceEnabled.add(db); // Mark as "handled"
            return false;
        }
        console.warn('[firebase/firestore] Failed to enable offline persistence. Continuing with memory cache:', error);
        persistenceEnabled.add(db); // Mark as "handled"
        return false;
    }
}
//# sourceMappingURL=index.js.map